/**
 * Resources articles — three organisational guides that give the
 * /resources category tiles somewhere real to link to. Every article
 * is data-driven so ops can add / edit without touching layout code.
 *
 * Legal rail: articles never provide regulated advice. Every article
 * carries the same "organisational, not financial advice" disclaimer.
 */
export const ARTICLES = {
    "organise-financial-life": {
        title: "How to organise a modern financial life in one place",
        category: "Financial Organisation",
        readTime: "5 min",
        summary: "A calm 30-minute setup — cards, subscriptions, documents and dates — that pays for itself for years.",
        sections: [
            { h: "Start with what you can see",
              p: "Open the two or three apps where money actually moves — your primary bank, your card app, one wallet. That list is almost always shorter than it feels." },
            { h: "Bring cards in first",
              p: "Cards are the fastest signal because they touch every category. Add each active card with its limit, its due date and one recent statement — that's enough to unlock Money Map." },
            { h: "Sweep subscriptions in one pass",
              p: "Pull last month's statement, mark each recurring line as a subscription in VAULT and set the renewal date. You'll spot at least one duplicate in the first pass." },
            { h: "Upload the documents you'd panic to lose",
              p: "Insurance, warranty, agreement, PAN, passport. Everything else can wait — these six make you feel calmer immediately." },
            { h: "Turn on the calendar",
              p: "Every payment, renewal and expiry has a date. VAULT's Financial Calendar remembers them so you don't." },
        ],
    },
    "family-finance-together": {
        title: "How couples and families organise money without losing privacy",
        category: "Family Finance Organisation",
        readTime: "6 min",
        summary: "Together when you want it, private when you need it — how VAULT's household surface actually works.",
        sections: [
            { h: "Everyone keeps their own login",
              p: "There is no shared password in a household VAULT. Every member signs in as themselves — that's the only way privacy can hold." },
            { h: "Pick a privacy preset on day one",
              p: "Fully Shared Couple, Balanced Privacy or Private First. Presets set defaults for new records; existing records keep their labels until you change them explicitly." },
            { h: "Ownership + visibility, per record",
              p: "Each record can be Personal, Partner, Joint, Household or Unassigned — and Private, Shared Summary, Shared Full or Selected Members. VAULT enforces this on every read." },
            { h: "Review before you invite",
              p: "The Privacy Review card shows exactly what a new member will see, per module, before you send the invite. There are no surprises." },
            { h: "Departure is calm too",
              p: "When a member leaves, personal records are exported to them, joint records reassign with the owner's confirmation, and private records never transfer to anyone." },
        ],
    },
    "document-first-mindset": {
        title: "The document-first mindset — why paperwork belongs next to the record",
        category: "Documents",
        readTime: "4 min",
        summary: "Insurance without the policy is a rumour. Here's how to keep every important paper next to the record it belongs to.",
        sections: [
            { h: "Connect the document to the record",
              p: "A warranty attached to a laptop, a policy attached to a car, an agreement attached to a property — one click keeps them together forever." },
            { h: "Give every document a friendly name",
              p: "\"Home_Ins_Renewal_2026.pdf\" is fine on disk. In VAULT, name it \"Home insurance · renews 2026-12\" — future-you will thank you." },
            { h: "Use expiry dates ruthlessly",
              p: "Every insurance policy, warranty and identity document has an expiry. VAULT flags them 90 / 60 / 30 / 7 days out so nothing renews under pressure." },
            { h: "Review, don't hoard",
              p: "Data Freshness tells you which documents haven't been touched in a year. Delete anything you no longer need — organisation is subtraction as much as addition." },
        ],
    },
};
